module.exports = __webpack_public_path__ + "media/photo/group294-6636bdae.png";